import { makeStyles } from "@mui/styles";
import { FontSize } from "src/const/font";

const useStyles = makeStyles((theme) => {
  return {
    styleDefault: {
      fontSize: FontSize.head.default,
      lineHeight: FontSize.head.default,
      fontWeight: 700,
      textAlign: "center",
      color: theme.custom?.text.title,
      paddingBottom: "48px",
      [theme.breakpoints.down("md")]: {
        textAlign: "left",
        lineHeight: FontSize.head.h3,
        fontSize: FontSize.head.h3,
        paddingBottom: "16px",
      },
    },
  };
});
interface PropsTextTitleI {
  style?: any;
  children: string | any;
  className?: string;
}

const HeaderTitle = (props: PropsTextTitleI) => {
  const { style, children, className } = props;
  const classes = useStyles();
  //! Render
  return (
    <>
      <p
        className={`${classes.styleDefault} ${className}`}
        style={{ ...style }}
      >
        {children}
      </p>
    </>
  );
};
export default HeaderTitle;
